import { render } from "./SymptomCanvas.vue?vue&type=template&id=690c482e&scoped=true"
import script from "./SymptomCanvas.vue?vue&type=script&lang=js"
export * from "./SymptomCanvas.vue?vue&type=script&lang=js"

import "./SymptomCanvas.vue?vue&type=style&index=0&id=690c482e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690c482e"]])

export default __exports__